<button
  [attr.type]="type"
  [routerLink]="$any(routerLink)"
  [ngClass]="buttonClasses"
  [disabled]="isInteractionBlocked"
  [attr.aria-label]="computedAriaLabel"
  [attr.aria-disabled]="isInteractionBlocked"
  [attr.aria-busy]="loading"
  [attr.aria-pressed]="active ? true : null"
  [attr.title]="title || null"
  (click)="onButtonClick($event)"
  (keydown)="onKeydown($event)"
>
  @if (loading) {
    <span class="app-btn__spinner" aria-hidden="true">
      <span class="app-btn__spinner-dot"></span>
    </span>
  }

  @if (showLeftIcon) {
    <i [class]="iconLeft + ' app-btn__icon app-btn__icon--left'" aria-hidden="true"></i>
  }

  <span class="app-btn__content" #contentWrapper>
    <ng-content></ng-content>
  </span>

  @if (showLabel) {
    <span class="app-btn__label">{{ label }}</span>
  }

  @if (showRightIcon) {
    <i [class]="iconRight + ' app-btn__icon app-btn__icon--right'" aria-hidden="true"></i>
  }
</button>
